import type { HorizontalAlign } from "../align/HorizontalAlign"
import type { VerticalAlign } from "../align/VerticalAlign"
import type { SpatialRectangle } from "../geometry/SpatialRectangle"
import type { Distance } from "../units/Units"
import type { ConcretePlotObject } from "./BasePlotObject"
import type { PlotFunction } from "./PlotFunction"

// Specific type for plot_text
export type PlotText = {
  func: PlotFunction.PLOT_TEXT
  text_color: string
  position: SpatialRectangle<Distance>
  text: string
  font_size?: number
  horizontal_align?: HorizontalAlign
  vertical_align?: VerticalAlign
  font_name?: string
} & ConcretePlotObject
